import { render } from "./OpenInvitations.vue?vue&type=template&id=a5fdb12e"
import script from "./OpenInvitations.vue?vue&type=script&lang=js"
export * from "./OpenInvitations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/embassy/windowOverlay/OpenInvitations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5fdb12e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5fdb12e', __exports__)) {
    api.reload('a5fdb12e', __exports__)
  }
  
  module.hot.accept("./OpenInvitations.vue?vue&type=template&id=a5fdb12e", () => {
    api.rerender('a5fdb12e', render)
  })

}


export default __exports__